import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import BottomNav from "./components/BottomNav";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Record from "./pages/Record";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Feed from "./pages/Feed";
import Friends from "./pages/Friends";
import PublicProfile from "./pages/PublicProfile";
import Onboarding from "./pages/Onboarding";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
    <div className="w-10 h-10 rounded-full border-2 border-[#CCFF00] border-t-transparent animate-spin" />
  </div>
);

function needsOnboarding(user) {
  return (
    user &&
    user.role !== "admin" &&
    user.age == null &&
    user.weight == null &&
    user.height == null &&
    !localStorage.getItem("onboarding_done")
  );
}

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-[#0A0A0A] pb-24">
      {children}
      <BottomNav />
    </div>
  );
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to={needsOnboarding(user) ? "/onboarding" : "/"} replace />;
  return children;
}

function ProtectedBare({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <div className="min-h-screen bg-[#0A0A0A]">{children}</div>;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/onboarding" element={<ProtectedBare><Onboarding /></ProtectedBare>} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/record" element={<Protected><Record /></Protected>} />
          <Route path="/history" element={<Protected><History /></Protected>} />
          <Route path="/feed" element={<Protected><Feed /></Protected>} />
          <Route path="/friends" element={<Protected><Friends /></Protected>} />
          <Route path="/u/:code" element={<Protected><PublicProfile /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
